__turbopack_context__.v({
  "alertYellow": "W5juna_alertYellow",
  "androidImg": "W5juna_androidImg",
  "appStoreButtons": "W5juna_appStoreButtons",
  "appleImg": "W5juna_appleImg",
  "backgroundImage": "W5juna_backgroundImage",
  "bannerItem": "W5juna_bannerItem",
  "black": "W5juna_black",
  "black90": "W5juna_black90",
  "content": "W5juna_content",
  "copy": "W5juna_copy",
  "copyContainer": "W5juna_copyContainer",
  "ctaContainer": "W5juna_ctaContainer",
  "cyan": "W5juna_cyan",
  "darkStone": "W5juna_darkStone",
  "fuschiaPunch": "W5juna_fuschiaPunch",
  "limeSorbet": "W5juna_limeSorbet",
  "olive100": "W5juna_olive100",
  "olive20": "W5juna_olive20",
  "paddedPageBanner": "W5juna_paddedPageBanner",
  "paddingBottom0": "W5juna_paddingBottom0",
  "paddingBottom112": "W5juna_paddingBottom112",
  "paddingBottom128": "W5juna_paddingBottom128",
  "paddingBottom16": "W5juna_paddingBottom16",
  "paddingBottom32": "W5juna_paddingBottom32",
  "paddingBottom48": "W5juna_paddingBottom48",
  "paddingBottom64": "W5juna_paddingBottom64",
  "paddingBottom80": "W5juna_paddingBottom80",
  "paddingBottom96": "W5juna_paddingBottom96",
  "paddingTop0": "W5juna_paddingTop0",
  "paddingTop112": "W5juna_paddingTop112",
  "paddingTop128": "W5juna_paddingTop128",
  "paddingTop16": "W5juna_paddingTop16",
  "paddingTop32": "W5juna_paddingTop32",
  "paddingTop48": "W5juna_paddingTop48",
  "paddingTop64": "W5juna_paddingTop64",
  "paddingTop80": "W5juna_paddingTop80",
  "paddingTop96": "W5juna_paddingTop96",
  "softBlack": "W5juna_softBlack",
  "teal100": "W5juna_teal100",
  "teal20": "W5juna_teal20",
  "warmStone": "W5juna_warmStone",
  "white": "W5juna_white",
});
